// Single source of truth for fonts and colors used across the app.
// Font keys must match the names registered with useFonts() in App.tsx.
export const fonts = {
  thin: "BarisSans_Thin",
  light: "BarisSans_Light",
  regular: "BarisSans_Regular",
  medium: "BarisSans_Medium",
  bold: "BarisSans_Bold",
};

export const colors = {
  primary: "#281C9D",
  primaryAlt: "#3629B7",
  buttonBg: "#4F46E5",
  white: "#FFFFFF",
  black: "#000000",
  textGray: "#979797",
  textGrayDark: "#666",
  textGrayDarker: "#343434",
  textGrayMuted: "#999",
  border: "#CBCBCB",
  borderLight: "#EEE",
  borderLighter: "#E0E0E0",
};

const theme = { fonts, colors };

export default theme;
